import { Action } from 'redux';
import { isSetVizPathAction } from '../actions/spaces/SetVizPathAction';

export const VizPathInitialState: string = '';

export function vizPathReducer(
  previousVizPath: string = VizPathInitialState,
  action: Action = null
): string {

  if(isSetVizPathAction(action) && previousVizPath !== action.vizPath) {
    return action.vizPath;
  }

  return previousVizPath;
}
